import { render, staticRenderFns } from "./DisableIcon.vue?vue&type=template&id=92098f94"
import script from "./DisableIcon.vue?vue&type=script&lang=js"
export * from "./DisableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports